export enum AmountStatus {
  NOT_PAID = 3,
  UNDERPAID = 2,
  OVERPAID = 1,
  EXACT = 0

}
